export default __webpack_public_path__ + "static/media/img_chart_grade_S-.98dde711c65138ba494867da7bc367a1.svg";